<template>
    <div>
        <div class="s-statistics__results__head">
            <h2 class="s-statistics__results__title">{{ appData.dictionary.byMonthSsxResultsTitle }}</h2>
        </div>
        <div class="s-statistics__table">
            <div class="s-statistics__tabs-nav">
                <a
                    v-for="(year, i) in resultsYears"
                    :key="'table-tab-' + i"
                    href="javascript:void(0)"
                    :class="['dotted-link', { active: activeTableYear == year }]"
                    @click="activeTableYear = year">
                    {{ year }}
                </a>
            </div>

            <div
                v-if="activeTab === 'values' && appData.dictionary.valuesWarningSsx?.length"
                class="s-statistics__notes">
                <div class="s-statistics__notes__cont" v-html="appData.dictionary.valuesWarningSsx"></div>
            </div>

            <article class="b-article">
                <table class="th-flex-height">
                    <thead>
                        <tr>
                            <th rowspan="2" style="vertical-align: top; padding-bottom: 5px">
                                <span>
                                    {{ appData.dictionary.tableMonth }}
                                    <a href="#btmNotes">({{ appData.dictionary?.tableMonthSsxNoteIndex }})</a>
                                </span>
                            </th>
                            <th rowspan="2" style="vertical-align: top; padding-bottom: 5px">
                                <span>
                                    <template v-if="activeTab === 'counts'">
                                        {{ appData.dictionary?.tableCountsSsx }}
                                    </template>
                                    <template v-if="activeTab === 'values'">
                                        {{ results.valuesSumTitle }}
                                    </template>
                                </span>
                            </th>
                            <th rowspan="2" style="vertical-align: top; padding-bottom: 5px">
                                <span>
                                    <template v-if="activeTab === 'counts'">
                                        {{ appData.dictionary?.tableCountsTaktopSsx }}
                                    </template>
                                    <template v-if="activeTab === 'values'">
                                        {{ appData.dictionary?.tableValuesTaktopSsx }}
                                    </template>
                                </span>
                            </th>
                            <th
                                :colspan="results.byMonth[0].perMonth.length"
                                style="border-bottom: none; padding-bottom: 5px">
                                <span>
                                    <template v-if="activeTab === 'counts'">
                                        {{ appData.dictionary?.tableCountsPerMonthSsx }}
                                        <a href="#btmNotes">({{ appData.dictionary?.tablePerMonthSsxNoteIndex }})</a>
                                    </template>
                                    <template v-if="activeTab === 'values'">
                                        {{ appData.dictionary?.tableValuesPerMonthSsx }}
                                        <a href="#btmNotes">({{ appData.dictionary?.tablePerMonthSsxNoteIndex }})</a>
                                    </template>
                                </span>
                            </th>
                        </tr>
                        <tr>
                            <th v-if="results.byMonth[0].perMonth[0]" style="padding-top: 0">
                                <span class="green-bold">1</span>
                            </th>
                            <th v-if="results.byMonth[1].perMonth[1]" style="padding-top: 0">
                                <span class="green-bold">2</span>
                            </th>
                            <th v-if="results.byMonth[2].perMonth[2]" style="padding-top: 0">
                                <span class="green-bold">3</span>
                            </th>
                            <th v-if="results.byMonth[3].perMonth[3]" style="padding-top: 0">
                                <span class="green-bold">
                                    4+
                                    <a href="#btmNotes">
                                        ({{ appData.dictionary?.tableCountsPerMonthSsxLastNoteIndex }})
                                    </a>
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, row_i) in tableMonthRows" :key="'row-' + row_i">
                            <td style="font-weight: 700">
                                {{ appData.dictionary?.months[row.month] }}
                            </td>
                            <td>
                                <template v-if="activeTab === 'counts'">
                                    {{ row.countSum.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.valueSum.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                            <td>
                                <template v-if="activeTab === 'counts'">
                                    {{ row.taktopCountSum.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.taktopValueSum.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                            <td v-if="row.perMonth.length">
                                <template v-if="activeTab === 'counts'">
                                    {{ row.perMonth[0].count.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.perMonth[0].value.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                            <td v-if="row.perMonth.length">
                                <template v-if="activeTab === 'counts'">
                                    {{ row.perMonth[1].count.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.perMonth[1].value.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                            <td v-if="row.perMonth.length">
                                <template v-if="activeTab === 'counts'">
                                    {{ row.perMonth[2].count.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.perMonth[2].value.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                            <td v-if="row.perMonth.length">
                                <template v-if="activeTab === 'counts'">
                                    {{ row.perMonth[3].count.toLocaleString(appData.configuration.locale) }}
                                </template>
                                <template v-if="activeTab === 'values'">
                                    {{ row.perMonth[3].value.toLocaleString(appData.configuration.locale) }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </article>
        </div>

        <div v-if="results.middleNote?.length" class="s-statistics__notes">
            <div class="s-statistics__notes__cont" v-html="results.middleNote"></div>
        </div>

        <div v-if="chart" class="s-statistics__charts">
            <h3 class="s-statistics__charts__title">
                {{ categoryName }}
                <template v-if="activeTab === 'counts'">{{ appData.dictionary?.chartCounts }}</template>
                <template v-if="activeTab === 'values'">{{ appData.dictionary?.chartValues }}</template>
            </h3>
            <div class="s-statistics__charts__items">
                <div class="s-statistics__charts__item">
                    <div class="s-statistics__chart">
                        <line-chart
                            :key="chartsUpdateKey"
                            :labels="chart.labels"
                            :datasets="chart.datasets"
                            :locale="appData.configuration.locale"
                            :is-amount="true"></line-chart>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="activeTab === 'values' && appData.dictionary.valuesWarningSsx?.length" class="s-statistics__notes">
            <div class="s-statistics__notes__cont" v-html="appData.dictionary.valuesWarningSsx"></div>
        </div>
    </div>
</template>

<script>
import statisticsMixins from 'Root/vue/mixins/statisticsMixins'
import LineChart from 'Root/vue/components/LineChart.vue'
import ScrollableTable from 'Root/ui/components/ScrollableTable.js'

export default {
    components: {
        LineChart,
    },

    mixins: [statisticsMixins],

    props: {
        results: {
            type: Object,
            default: () => {
                return {}
            },
        },
        activeTab: {
            type: String,
            default: '',
        },
        category: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            activeChartTab: '',
            activeTableYear: '',

            resultsYears: [],

            chart: [],
            chartsUpdateKey: 0,
        }
    },

    computed: {
        categoryName() {
            return this.appData.filters.categories.find((i) => i.value === this.category)?.text
        },
        tableMonthRows() {
            return this.results.byMonth.filter((i) => i.year === this.activeTableYear)
        },
    },

    watch: {
        activeTab() {
            this.iniTableMonthsData()
            this.iniChartsData()

            this.chartsUpdateKey++
        },
    },

    mounted() {
        this.iniTableMonthsData()
        this.iniChartsData()

        document.querySelectorAll('.b-article table').forEach((elem) => {
            elem.ScrollableTable = new ScrollableTable(elem)
        })
    },

    methods: {
        iniTableMonthsData() {
            this.resultsYears = []

            this.results.byMonth.forEach((resultItem) => {
                if (!this.resultsYears.includes(resultItem.year)) {
                    this.resultsYears.push(resultItem.year)
                }
            })

            this.activeTableYear = this.resultsYears[0]
        },
        iniChartsData() {
            const labels = this.createChartMonthsLabels(this.results.byMonth)

            if (this.activeTab === 'counts') {
                this.chart = {
                    labels: labels,
                    datasets: [
                        {
                            label: this.appData.dictionary.tableCountsSsx,
                            data: this.results.byMonth.map((i) => i.countSum),
                        },
                        {
                            label: this.appData.dictionary.tableCountsTaktopSsx,
                            data: this.results.byMonth.map((i) => i.taktopCountSum),
                        },
                    ],
                }
            } else if (this.activeTab === 'values') {
                this.chart = {
                    labels: labels,
                    datasets: [
                        {
                            label: this.results.valuesSumTitle,
                            data: this.results.byMonth.map((i) => i.valueSum),
                        },
                        {
                            label: this.appData.dictionary?.tableValuesTaktopSsx,
                            data: this.results.byMonth.map((i) => i.taktopValueSum),
                        },
                    ],
                }
            }

            this.activeChartTab = 'counts'
        },
    },
}
</script>
